.bottomBar {
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #e5e5e5;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 12px;
  padding: 16px 24px calc(16px + env(safe-area-inset-bottom, 0px));
  width: 100%;
  z-index: 10;
}

.subscribe {
  background: transparent;
  border: 1px solid var(--brand-button-color);
  border-radius: 30px;
  color: var(--brand-button-color);
  cursor: pointer;
  font-weight: 600;
  max-width: 480px;
  padding: 14px 28px;
}

.subscribe:hover {
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.12);
}

.login {
  background: transparent;
  border: 0;
  color: var(--brand-button-color);
  cursor: pointer;
  font-weight: 600;
  padding: 4px 8px;
}

.login:hover {
  text-decoration: underline;
}
